import { initJSExtensions } from "./extensions/init_js_extentions";

export function initJSPlugins(engine) {
    initJSExtensions(engine);
}